import React, { useState } from "react";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Result,
  Modal,
} from "antd";
import logo from "../../img/Untitled-2.png";
import { useSendMsgMutation } from "../../redux/gemo/gemo";
import CheckGemo from "./CheckGemo";
import { useTranslation } from "react-i18next";
import ChangeLang from "../ChangeLang";
import InputMask from "react-input-mask";
import SendGemoVerify from "./SendGemoVerify";

function FormGemo() {
  const { Option } = Select;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [change, setChange] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenVerify, setIsModalOpenVerify] = useState(false);
  const [verifyData, setVerifyData] = useState();
  const [sendMsg, { isLoading, data }] = useSendMsgMutation();
  const alertMsg = data?.token;

  const onFinish = async (values) => {
    const dataMsg = {
      department: values.section,
      roomNumber: values.numberRoom,
      problem: values.problem,
      name: values.name,
      surname: values.surName,
      phoneNumber: values.phone,
      ip: "",
    };
    await setVerifyData(dataMsg);
    setIsModalOpenVerify(true);
  };
  const handleOK = () => {
    setIsModalOpen(false);
    window.location.reload(false);
  };
  const showDrawer = () => {
    setOpen(true);
  };

  return (
    <div className="form">
      <SendGemoVerify
        vrOpen={isModalOpenVerify}
        vrClose={setIsModalOpenVerify}
        vrData={verifyData}
      />
      <CheckGemo open={open} setOpen={setOpen} />

      <Modal
        title=""
        open={isModalOpen}
        closeIcon={false}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <Result
          status="success"
          title="Sizning arizangiz qabul qilindi!"
          subTitle={`Ariza raqami ${alertMsg}`}
          extra={[
            <Button type="primary" key="console" onClick={handleOK}>
              ok
            </Button>,
          ]}
        />
      </Modal>
      <div className="form__item">
        <nav>
          <div className="form__logo">
            <img src={logo} className="imgOnco" alt="logo" />
          </div>
          <div className="form__check">
            <Button onClick={showDrawer}>{t("nav.2")}</Button>
            <ChangeLang />
          </div>
        </nav>
        <Form layout="vertical" name="control-ref" onFinish={onFinish}>
          <h1>{t("titles.0")}</h1>

          <Form.Item
            name="section"
            label={t("titles.1")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select placeholder={t("deportmanGemo.0")} allowClear>
              <Option value={t("deportmanGemo.1")}>
                {t("deportmanGemo.1")}
              </Option>
              <Option value={t("deportmanGemo.2")}>
                {t("deportmanGemo.2")}
              </Option>
              <Option value={t("deportmanGemo.3")}>
                {t("deportmanGemo.3")}
              </Option>
              <Option value={t("deportmanGemo.4")}>
                {t("deportmanGemo.4")}
              </Option>
              <Option value={t("deportmanGemo.41")}>
                {t("deportmanGemo.41")}
              </Option>
              <Option value={t("deportmanGemo.5")}>
                {t("deportmanGemo.5")}
              </Option>
              <Option value={t("deportmanGemo.6")}>
                {t("deportmanGemo.6")}
              </Option>
              <Option value={t("deportmanGemo.7")}>
                {t("deportmanGemo.7")}
              </Option>
              <Option value={t("deportmanGemo.8")}>
                {t("deportmanGemo.8")}
              </Option>
              <Option value={t("deportmanGemo.9")}>
                {t("deportmanGemo.9")}
              </Option>
              <Option value={t("deportmanGemo.10")}>
                {t("deportmanGemo.10")}
              </Option>
              <Option value={t("deportmanGemo.11")}>
                {t("deportmanGemo.11")}
              </Option>
              <Option value={t("deportmanGemo.12")}>
                {t("deportmanGemo.12")}
              </Option>
              <Option value={t("deportmanGemo.13")}>
                {t("deportmanGemo.13")}
              </Option>
              <Option value={t("deportmanGemo.14")}>
                {t("deportmanGemo.14")}
              </Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="numberRoom"
            label={t("titles.2")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="problem"
            label={t("titles.3")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            {!change ? (
              <Select placeholder={t("problem.0")} allowClear>
                <Option value={t("problem.1")}>{t("problem.1")}</Option>
                <Option value={t("problem.2")}>{t("problem.2")}</Option>
                <Option value={t("problem.3")}>{t("problem.3")}</Option>
                <Option value={t("problem.4")}>{t("problem.4")}</Option>
                <Option value={t("problem.5")}>{t("problem.5")}</Option>
              </Select>
            ) : (
              <Input />
            )}
          </Form.Item>
          <Form.Item>
            <Checkbox onChange={(e) => setChange(e.target.checked)}>
              {t("titles.4")}
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="name"
            label={t("titles.5")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="surName"
            label={t("titles.6")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone"
            label={t("titles.7")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputMask
              className="phoneInp ant-input-number ant-input-number-input"
              mask="99-999-99-99"
              required
            />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary" block>
              {t("titles.8")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default FormGemo;
